<template lang="pug">
v-select(:name="name", :label="label", v-model="itemIndex",
  :menu-props="{ zIndex: 10009, maxHeight: maxHeight }"
  @input="select", :items="itemsSorted",
  :class="$style.required",
  :rules="[rules.required]",
  item-text="title", item-value="index", :max-height="maxHeight", required)
  template(slot="item", slot-scope="data")
    div(:class="[$style.wrapperCase, data.item.id == requestTypeId && $style.isActive]")
      v-list-item-content
        v-list-item-title.caseTitle(v-if="data.item.title")
          span(:class="$style.description") {{ data.item.title }}
        v-list-item-subtitle.message(v-if="showLastMessage(data.item)")
          .bodyWrapper
            .body {{ data.item.lastNonSystemMessage.body }}
          .date {{ data.item.lastNonSystemMessage.insertedAt | formatDateTime }}
        v-list-item-subtitle.desc(v-else)
          span(:class="$style.description") {{ data.item.description ? data.item.description : data.item.desc }}
      v-list-item-action(v-if="data.item.messagesCount > 0")
        v-list-item-action-text.count {{ data.item.messagesCount }}
</template>

<script>
import { mapActions } from 'vuex';
import { findIndex, sortBy, orderBy } from 'lodash';
import { appendIndexForEachElement } from 'src/utils';
import { requiredRule } from 'src/utils/helper';

async function getRequestType(vm) {
  vm.label = vm.$t('T_SELECT_REQUEST_TYPE');
  return appendIndexForEachElement(await vm.getRequestTypes());
}

export default {
  name: 'intents-control',
  props: {
    type: {
      type: String,
      required: false,
      validator: (type) => ['requestType'].includes(type),
    },
    name: null,
    requestTypeId: null,
    channelId: null,
  },
  data() {
    return {
      itemIndex: null,
      label: '',
      items: [],
      rules: {
        required: requiredRule,
      },
    };
  },
  async mounted() {
    if (this.type === 'requestType') {
      this.items = await getRequestType(this);
    } else {
      await this.updateCases();
    }
  },
  computed: {
    maxHeight() {
      const avaliableHeight = this.$root.height;
      if (avaliableHeight) return avaliableHeight;
      return 'auto';
    },
    showLastMessage() {
      return (caseValue) => caseValue.lastNonSystemMessage && !this.type && caseValue.type === 'case';
    },
    itemsSorted() {
      if (this.type === 'requestType') {
        return sortBy(this.items, (item) => item.title.toLowerCase());
      } return this.items;
    },
  },
  methods: {
    ...mapActions('demo', ['getIntents', 'getRequestTypes']),
    select(index) {
      this.$emit('select', this.items[index]);
    },
    async updateCases() {
      this.label = this.$t('T_SELECT_REQUEST_TYPE_OR_CASE');
      const intents = await this.getIntents();
      // TODO После серверной реализации подтягивания связей нужно удалить лишний запрос
      const intentsList = [];
      if (intents.requestTypes.length > 0) {
        const sortedRequestTypes = sortBy(intents.requestTypes, (item) => item.title.toLowerCase());
        intentsList.push({ header: this.$t('T_REQUEST_TYPES') });
        intentsList.push(...sortedRequestTypes);
      }
      if (intents.openCases.length > 0 && intents.requestTypes.length > 0) {
        intentsList.push({ divider: true });
      }
      if (intents.openCases.length > 0) {
        const sortedOpenCases = orderBy(intents.openCases, 'updatedAt', 'desc');
        intentsList.push({ header: this.$t('T_OPEN_CASES') });
        intentsList.push(...sortedOpenCases);
      }
      this.items = appendIndexForEachElement(intentsList);
      return appendIndexForEachElement(intentsList);
    },
  },
};
</script>

<style lang="sass" module>
.isActive
  &::before
    content: ''
    background: $color_transparent_bg_dark
    position: absolute
    left: -16px
    top: 0
    width: calc(100% + 32px)
    height: 100%

.wrapperCase
  width: 100%
  display: flex
  align-items: center
  height: 100%

.description
  display: flex
  max-width: 400px
  word-break: break-word
  overflow-wrap: break-word
  white-space: normal
  width: 100%
</style>

<style lang="sass" scoped>
.bodyWrapper
  overflow: hidden
.count
  background: $color_red
  border-radius: 12px
  color: $white
  font-weight: bold
  padding: 3px 9px
.caseTitle
  overflow: visible
.desc
  word-break: break-word
  overflow-wrap: break-word
  white-space: normal
  max-width: 100%
.message
  display: flex
  flex: 0 1 100%
  justify-content: space-between
  align-items: center
  font-size: 10px
  width: 100%
  .body
    text-overflow: ellipsis
    max-width: 235px
    overflow: hidden
  .date
    display: inline-block
    font-weight: bold
.required label::after
  content: "*"
  color: $color_red
</style>
